<script>
import vLable from '@/components/Features/Label'
import img1 from '@/assets/template3.png'
import img2 from '@/assets/template5.png'
import img3 from '@/assets/ipassadult.png'
import img4 from '@/assets/Asset3@8x.png'
import img5 from '@/assets/22250.png'
import img6 from '@/assets/22251.png'
export default {
  props: {
    cardFontEgText: {
      type: String,
      default: ''
    },
    cardFontText: {
      type: String,
      default: ''
    },
    cardImg: {
      type: String,
      default: ''
    },
    cardImgCss: {
      type: String,
      default: ''
    }
  },
  components: {
    vLable
  },
  data () {
    return {
      img1: img1,
      img2: img2,
      img3: img3,
      img4: img4,
      img5: img5,
      img6: img6
    }
  },
  computed: {
    computedIMG () {
      var imgs
      switch (this.cardImg) {
        case '1':
          imgs = this.img1
          break
        case '2':
          imgs = this.img2
          break
        case '3':
          imgs = this.img3
          break
        case '4':
          imgs = this.img4
          break
        case '5':
          imgs = this.img5
          break
        case '6':
          imgs = this.img6
          break
      }
      return imgs
    }
  }
}
</script>

<template>
  <div class="paycard">
    <div style="padding: 5px;height: 115px;">
      <img
        class="card-img-top"
        alt="Card"
        :class="cardImgCss"
        :src='[computedIMG]'
      >
    </div>
    <hr>
    <v-lable :lab-text="cardFontText">
      <v-font
        slot="small"
        font-css="spanfss"
        :font-text="cardFontEgText"
      />
    </v-lable>
    <slot name="cardbr" />
    <slot name="link" />
  </div>
</template>

<style lang="scss">
.paycard {
  border: 1px #000 solid;
  border-radius: 5px;
  background-color:#fff;
  text-align: center;
  width: 180px;
  position:relative;
  z-index: 2;
}
.imgline {
  position: absolute;
  top: 20%;
  right: 4%;
  width: 90%;
  z-index: -1;
}
</style>
